﻿export function isContainsElement(parents: HTMLElement | HTMLElement[], target: HTMLElement):boolean {
    if (parents) {
        if (Array.isArray(parents)) {
            return parents.some(item => item.contains(target));
        } else {
            return parents.contains(target);
        }
    }
    return false;
}